export const hrTodaysAttendanceApi = {
    heading:[
        {
            head:"Name"
        },
        {
            head:"ID"
        },
        {
            head:"In Time"
        },
        {
            head:"Out Time"
        },
        {
            head:"Time Late"
        },
        {
            head:"Status"
        },
    ],
    data:[
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"takib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Absent"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Late"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Leave"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
        {
            name:"akib",
            id:"46546",
            intime:"09:30AM",
            outtime:"04:00PM",
            timelate:"00:30Min",
            status:"Present"
        },
    ]
}